<script setup lang="ts"></script>

<template>
  <h1>Hi there!</h1>
  <p class="teaser">
    This is the website for our desk booking system.<br />
    It looks like you don't have a secret key.
  </p>
</template>

<style scoped></style>
